import { INNER_ROUTES } from '../constants';
import {
  Address,
  FAQs,
  PassKeys,
  PaymentMethods,
  PurchaseHistory,
  Setting,
} from '../views/pages';

export const innerLayoutRoutes = [
  { path: INNER_ROUTES.PAYMENT_METHODS, element: <PaymentMethods /> },
  { path: INNER_ROUTES.PURCHASE_HISTORY, element: <PurchaseHistory /> },
  { path: INNER_ROUTES.SETTINGS, element: <Setting /> },
  { path: INNER_ROUTES.ADDRESSES, element: <Address /> },
  { path: INNER_ROUTES.PASSKEYS, element: <PassKeys /> },
  { path: INNER_ROUTES.FAQS, element: <FAQs /> },
];
